import type { UpdateBucketMetadataData } from '@/entities/bucket';
import request from '@/shared/api/request';

export const updateBucketMetadata = (
  { name, file }: { name: string; file: string },
  data: Partial<UpdateBucketMetadataData>,
): Promise<unknown> =>
  request({
    url: `/buckets/${name}/objects/${file}/metadata/`,
    method: 'PUT',
    data,
  });
